module.exports = "pegasus/assets/themelp1/simple/104.png";